var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.loading
      ? _c(
          "div",
          { attrs: { id: "loading" } },
          [
            _c("vue-content-loading", { attrs: { width: 400, height: 20 } }, [
              _c("circle", { attrs: { cx: "12", cy: "10.62", r: "6.6" } }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "25",
                  y: "8",
                  rx: "2",
                  ry: "4",
                  width: "50",
                  height: "4.16",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "80",
                  y: "8",
                  rx: "2",
                  ry: "4",
                  width: "50",
                  height: "4.16",
                },
              }),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading",
          },
        ],
        staticClass: "row header align-items-center",
      },
      [
        _c("div", { staticClass: "col-12 font-italic text-right text-grey" }, [
          _vm.saving
            ? _c("p", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.$t("global.words.saving")) + ".."),
              ])
            : _vm.details
            ? _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.actions.lastSaved")) +
                    ":\n        " +
                    _vm._s(_vm._f("formatTimeAgo")(_vm.details.updatedAt)) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-xxl-auto col-xl-auto col order-1 vertical-center mb-2",
          },
          [
            _c("back-button", { attrs: { "fallback-route": "boards" } }),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass:
                  "header-title mb-0 d-flex align-items-center justify-content-start",
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.details.givenName) +
                    " " +
                    _vm._s(_vm.details.familyName) +
                    "\n        "
                ),
                _vm.details.accountStatus === "active"
                  ? _c(
                      "i",
                      {
                        staticClass:
                          "material-icons registered-tooltip text-primary mx-1",
                        attrs: {
                          "aria-hidden": "true",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: _vm.$t(
                            "global.messages.clientIsRegisteredInPlatform"
                          ),
                        },
                      },
                      [_vm._v("how_to_reg")]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.details.labelText
              ? _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("show-duplicate-modal", true)
                      },
                    },
                  },
                  [
                    _c(
                      "badge",
                      {
                        staticClass: "ml-1 mb-0 clickable",
                        style:
                          "background-color: " +
                          _vm.details.labelColour +
                          " !important",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.details.labelText) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.details.labelText
              ? _c(
                  "span",
                  { staticStyle: { "margin-left": "1em" } },
                  [
                    _c("icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: _vm.$t("client-profile.actions.addLabel"),
                          expression: "$t('client-profile.actions.addLabel')",
                        },
                      ],
                      staticClass: "text-primary mr-1 fa-2x",
                      attrs: { name: "tag" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("show-duplicate-modal", false, true)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xl col-12 order-3 order-xl-2 mb-xl-0 mb-3" },
          [
            _c("div", { staticClass: "row align-items-center" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.details.owner,
                      expression: "details.owner",
                    },
                  ],
                  staticClass:
                    "col-sm-auto col-12 mb-sm-0 mb-2 d-flex flex-xl-row flex-column align-items-start align-items-xl-center",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("client-profile.messages.assignedTo")) +
                      ":\n          "
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown dropdown-owner ml-xl-3 ml-0 vertical-center",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-white d-flex align-items-center dropdown-toggle",
                          staticStyle: { "white-space": "normal" },
                          attrs: {
                            id: "ownerDropdown",
                            "data-toggle": "dropdown",
                            disabled: _vm.disableDropdown,
                          },
                        },
                        [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              { staticClass: "client-profile-owner-avatar" },
                              "profile-avatar",
                              _vm.details.owner,
                              false
                            )
                          ),
                          _vm._v(" "),
                          _vm.details.owner
                            ? _c("span", { staticClass: "mx-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("nameFormat")(
                                      _vm.details.owner.givenName,
                                      _vm.details.owner.familyName
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _vm.boardId
                            ? _c("collaborators-dropdown", {
                                attrs: {
                                  "client-profile-id": _vm.clientProfileId,
                                  "board-id": _vm.boardId,
                                  profile: _vm.profile,
                                },
                                on: {
                                  "disable-dropdown": function ($event) {
                                    _vm.disableDropdown = true
                                  },
                                  "enable-dropdown": function ($event) {
                                    _vm.disableDropdown = false
                                  },
                                  "change-ownership": _vm.handleChangeOwnership,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-auto col-12 d-flex flex-row flex-fill justify-content-between",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-xl-row flex-column align-items-start align-items-xl-center text-center",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("email.messages.emailTracking")) +
                          ":\n            "
                      ),
                      _c("client-profile-collaborators", {
                        attrs: {
                          "client-profile-id": _vm.clientProfileId,
                          "board-id": _vm.boardId,
                          profile: _vm.profile,
                        },
                        on: {
                          change: _vm.updateEmailSync,
                          "add-remove-collaborator":
                            _vm.handleAddRemoveCollaborator,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-auto order-2 order-xl-3" },
          [
            _c("client-profile-header-action-button", {
              ref: "clientProfileHeaderActionButton",
              attrs: {
                "loading-state": _vm.actionButtonLoadingState,
                "silent-loading": _vm.silentLoading,
                "client-profile-details": _vm.details,
                "client-profile-id": _vm.clientProfileId,
              },
              on: { "select-board": _vm.handleBoardSelect },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "deleteProfileModal",
            staticClass: "modal fade",
            attrs: {
              id: "delete-client-profile-modal",
              tabindex: "-1",
              role: "dialog",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-dialog-centered",
                attrs: { role: "document" },
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("client-profile.actions.deleteClientProfile")
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": "Close",
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "client-profile.actions.deleteClientConfirmation"
                            )
                          ) +
                          "?\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("global.words.no")) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "deleteProfileButton",
                        staticClass: "btn btn-danger",
                        attrs: {
                          id: "delete-client-profile-button",
                          type: "button",
                        },
                        on: { click: _vm.deleteProfile },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("global.words.yes")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }